import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import FamilyTherapyPage from "./pages/FamilyTherapyPage";
import PersonalTherapyPage from "./pages/PersonalTherapyPage";
import CoupleTherapyPage from "./pages/CoupleTherapyPage";
import Header from "./components/Header";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="App font-hebrew">
      <BrowserRouter>
        <Header />
        <main className="min-h-screen pb-16">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/family" element={<FamilyTherapyPage />} />
            <Route path="/personal" element={<PersonalTherapyPage />} />
            <Route path="/couple" element={<CoupleTherapyPage />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
